export interface PrintState {  
  hasLoadedScreener: boolean;
  hasLoadedInitialAssessment: boolean;
  hasLoadedSelfAssessment: boolean;
  hasLoadedQandA: boolean;
  hasLoadedLearnerRecordTab: boolean;
  hasLoadedSkillsCheck: boolean;
  hasLoadedSkillsCheckQandA: boolean;
  hasLoadedWrittenAssignment: boolean;

  printLoader: boolean
}

export const initialPrintState: PrintState = {
  hasLoadedScreener: false,
  hasLoadedInitialAssessment: false,
  hasLoadedSelfAssessment: false,
  hasLoadedQandA: false,
  hasLoadedLearnerRecordTab: false,
  hasLoadedSkillsCheck: false,
  hasLoadedSkillsCheckQandA: false,
  hasLoadedWrittenAssignment: false,

  printLoader: false
}